import { CSSObject } from '@chakra-ui/react';
import background from '../../../assets/volcanobet/images/backgrounds/location-unavailable-desktop.png';
import backgroundAtRetina from '../../../assets/volcanobet/images/backgrounds/location-unavailable-desktop@2x.png';
import lavaBottomBackground from '../../../assets/volcanobet/images/backgrounds/location-unavailable-bottom-pattern.png';

export const LocationNotAllowedContainer: CSSObject = {
  h: undefined,
  justifyContent: [null, null, 'center'],
  minH: '100dvh',
  bgImage: `url(${background})`,
  bgRepeat: 'repeat',
  bgSize: ['50%', '30%'],
  lineHeight: '4',

  '@media (-webkit-min-device-pixel-ratio: 2)': {
    bgImage: `url(${backgroundAtRetina})`,
  },

  _after: {
    w: '100%',
    content: `''`,
    bgImage: `url(${lavaBottomBackground})`,
    bgPos: 'bottom',
    bgRepeat: 'repeat-x',
    bgSize: '660px',
    pos: 'absolute',
    bottom: 0,
    height: '230px',
  },
};

export const CenterWrapper: CSSObject = {
  bg: 'transparent',
  borderRadius: [null, null, 'xl'],
  color: 'white',
  flex: ['1', null, '0'],
  gap: '0',
  justifyContent: 'center',
  mt: ['0', null, '12'],
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  maxW: 'container.md',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
};

export const ContentHeadingText: CSSObject = {
  fontFamily: 'Caveman',
  fontSize: ['5xl', null, '6xl'],
  lineHeight: ['8', null, '10'],
  mt: ['1.5', null, '4'],
  mb: ['2.5', null, '4'],
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',
};

export const ContentBodyText: CSSObject = {
  fontSize: ['md', 'lg'],
  lineHeight: 'tall',
  textAlign: 'center',
  filter: 'drop-shadow(0px 5px 5px rgba(0,0,0,.5))',

  b: {
    display: 'block',
    fontSize: 'md',
    lineHeight: 'base',
    mb: '4',
  },

  '.chakra-link': {
    fontSize: ['2xs', 'xs'],
    fontWeight: 'bold',
  },
};

export const ContactText: CSSObject = {
  '&&': {
    fontSize: ['sm', null, 'lg'],
  },
};

export const TextBodyCopy: CSSObject = {
  lineHeight: '5',
  fontSize: ['sm', null, 'lg'],
};

export const TextHeadingColor: CSSObject = {
  bgGradient: 'linear(to-b, alpha.500, gamma.500)',
  bgClip: 'text',
  textShadow: 'none',
  display: 'flex',
};

export const RegistrationContent: CSSObject = {
  fontSize: ['xs', null],

  '.chakra-link': {
    fontSize: ['xs', null],
    fontWeight: 'bold',
  },
};
